import UnitPage from './pages/unit';
import StartPage from './pages/start';
import Search from './pages/search';
import Statistics from './pages/statistics';
import DataEntry from './pages/dataentry';
import Report from './pages/report';
import Monitor from './pages/monitor';
import Categories from './pages/categories';
import Notifications from './pages/notifications';
import Districts from './pages/districts';
import CreateClassification from './pages/districts/create-classification';
import CreateDistricts from './pages/districts/create-districts';
import MyFiles from './pages/myfiles';
import Profile from './pages/profile';
import Blog from './pages/blog';
import Post from './pages/blog-item';
import MyPublications from './pages/mypublications';
import Publication from './pages/mypublications/publication';

const routes = [
    {
        path: '/',
        exact: true,
        component: StartPage,
    },
    {
        path: '/unit/:unitId',
        component: UnitPage
    },
    {
        path: '/search',
        component: Search
    },
    {
        path: '/company/:companyId/branch/:branchId/report/:env/:report',
        component: Report
    },
    {
        path: '/company/:companyId/branch/:branchId/period/:periodId',
        component: DataEntry
    },
    {
        path: '/company/:companyId/branch/:branchId',
        component: DataEntry
    },
    {
        path: '/company/:companyId',
        component: Statistics
    },
    {
        path: '/company',
        component: Statistics
    },
    {
        path: '/categories',
        component: Categories
    },
    {
        path: '/myfeed',
        component: Monitor
    }, 
    {
        path: '/myfiles',
        component: MyFiles
    }, 
    {
        path: '/notifications',
        component: Notifications
    }, 
    {
        path: '/scenario/:scenarioId/create/:id',
        component: CreateDistricts,
        type: 'livs',
        hideHeader: true
    }, 
    {
        path: '/foodservice-scenario/:scenarioId/create/:id',
        component: CreateDistricts,
        type: 'foodservice',
        hideHeader: true
    }, 
    {
        path: ['/scenario/:scenarioId/classifications/create/', '/scenario/classifications/create/'],
        exact: true,
        component: CreateClassification
    },
    {
        path: ['/scenario/create', '/scenario/:scenarioId/create'],
        component: CreateDistricts,
        type: 'livs',
        hideHeader: true
    }, 
    {
        path: ['/foodservice-scenario/create', '/foodservice-scenario/:scenarioId/create'],
        component: CreateDistricts,
        type: 'foodservice',
        hideHeader: true
    },
    {
        path: ['/scenario/:scenarioId/classifications/create/:id', '/scenario/classifications/create/:id', '/districts/classifications/create/:id'],
        component: CreateClassification
    }, {
        path: ['/districts', '/scenario', '/scenario/:id'],
        type: 'livs',
        component: Districts
    },
    {
        path: ['/foodservice-districts', '/foodservice-scenario', '/foodservice-scenario:id'],
        type: 'foodservice',
        component: Districts
    }, {
        path: '/publications/:id',
        component: Publication
    }, {
        path: '/publications',
        component: MyPublications
    }, {
        path: '/profile',
        component: Profile
    }, {
        path: '/news',
        exact: true,
        component: Blog
    }, {
        path: '/news/tag/:tag',
        exact: true,
        component: Blog
    },
    {
        path: '/news/:slug',
        component:Post,
    },
];

export default routes;